import React from "react";
import { useTranslation } from "react-i18next";
import { ContentDiv } from "components/containers";
import { JobSection, Members, SectionHeader, TeamSection } from "./styles";
import { ResponsiveImage } from "../../../components/ResponsiveImage";
import { EE, GR, HR, IT, NL, RU } from "../../../components/Icons/Flags";
import { StyledButton } from "../../../components/generic";
import { useNavigate } from "react-router-dom";
import { VACANCIES_ROUTE } from "../../../utils/constants";

export const Team: React.FC = () => {
    const { t, i18n } = useTranslation('team');
    const navigate = useNavigate();

    const COUNTRIES: { [key: string]: { name: string, icon: JSX.Element } } = {
        "NL": {
            name: "The Netherlands",
            icon: NL
        },
        "EE": {
            name: "Estonia",
            icon: EE
        },
        "RU": {
            name: "Russia",
            icon: RU
        },
        "GR": {
            name: "Greece",
            icon: GR
        },
        "HR": {
            name: "Croatia",
            icon: HR
        },
        "IT": {
            name: "Italy",
            icon: IT
        },
    }

    interface IMember {
        name: string
        role: string
        image: string
        born: string
        currently: string
        born_city: string | undefined
        currently_city: string | undefined
    }

    const MEMBERS_DICT: IMember[] = [
        {
            name: "Daan Donkers",
            role: "Co-Founder",
            image: "team/daan",
            born: "NL",
            born_city: "Vught",
            currently: "NL",
            currently_city: "Utrecht",
        },
        {
            name: "Joost Bokkers",
            role: "Co-Founder",
            image: "team/joost",
            born: "NL",
            born_city: "Vught",
            currently: "NL",
            currently_city: "Amsterdam",
        },
        {
            name: "Maurits Barendregt",
            role: "Co-Founder",
            image: "team/maurits",
            born: "NL",
            born_city: "Bilthoven",
            currently: "NL",
            currently_city: "Utrecht",
        },
        {
            name: "Pavla Shvetcova",
            role: "Local Promoter Rotterdam / Marketing Manager",
            image: "team/pavla",
            born: "RU",
            born_city: undefined,
            currently: "NL",
            currently_city: undefined,
        },
        {
            name: "Wouter Stam",
            role: "Local Promoter Leiden",
            image: "team/wouter",
            born: "NL",
            born_city: undefined,
            currently: "NL",
            currently_city: undefined,
        },
        {
            name: "Erki Elbrecht",
            role: "Front-end Developer",
            image: "team/erki",
            born: "EE",
            born_city: "Tallinn",
            currently: "NL",
            currently_city: "Leiden",
        },
        {
            name: "Flavia Gkioka",
            role: "Local Promoter Groningen",
            image: "team/flavia",
            born: "GR",
            born_city: undefined,
            currently: "NL",
            currently_city: undefined,
        },
        {
            name: "Job Bijlsma",
            role: "Local Promoter Maastricht",
            image: "team/job",
            born: "NL",
            born_city: undefined,
            currently: "NL",
            currently_city: undefined,
        },
        {
            name: "Magdalena Hajduk",
            role: "Local promoter Utrecht",
            image: "team/magdalena",
            born: "HR",
            born_city: undefined,
            currently: "NL",
            currently_city: undefined,
        },
        {
            name: "Thierry van Benten",
            role: "UI, UX & Product Designer",
            image: "team/thierry",
            born: "NL",
            born_city: "Utrecht",
            currently: "NL",
            currently_city: "Amsterdam",
        }
    ]

    return (
        <ContentDiv>
            <h1>{t("team.title")}</h1>
            <TeamSection>
                <SectionHeader>{t("team.teamSection.header")}</SectionHeader>
                <h2>{t("team.teamSection.title")}</h2>
                <p>{t("team.teamSection.description")}</p>
                <Members>
                    {MEMBERS_DICT.map((value) =>
                        <div>
                            <ResponsiveImage
                                className={"image"}
                                imgSrc={value.image}
                                mobileSize={'95vw'}
                                tabletSize={'40vw'}
                                desktopSize={'25vw'}
                            />
                            <h1>{value.name}</h1>
                            <h2>{value.role}</h2>
                            <h3>Born in</h3>
                            <p>{COUNTRIES[value.born].icon} {value.born_city ? value.born_city + ", " : ""}{COUNTRIES[value.born].name}</p>
                            <h3>Currently in</h3>
                            <p>{COUNTRIES[value.currently].icon} {value.currently_city ? value.currently_city + ", " : ""}{COUNTRIES[value.currently].name}</p>
                        </div>
                    )}
                </Members>
            </TeamSection>
            <JobSection>
                <ResponsiveImage
                    className={"image"}
                    imgSrc={"rootpage/team/hospita-3"}
                    mobileSize={'95vw'}
                    tabletSize={'40vw'}
                    desktopSize={'40vw'}
                />
                <div>
                    <SectionHeader>{t("team.jobSection.header")}</SectionHeader>
                    <h2>{t("team.jobSection.title")}</h2>
                    <p>{t("team.jobSection.description")}</p>
                    <StyledButton
                        onClick={() => navigate(`/${i18n.language}${VACANCIES_ROUTE.slice(5)}`)}>
                        {t("team.jobSection.button")}
                    </StyledButton>
                </div>
            </JobSection>
        </ContentDiv>
    );
}
